export const ERROR_CODES = {
  ERR_NETWORK: 'ERR_NETWORK',
  NOT_FOUND: 'NOT_FOUND',
  WRONG_PASSWORD: 'WRONG_PASSWORD',
  DISABLED_ACCOUNT: 'DISABLED_ACCOUNT',
  EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
  STORE_ALREADY_EXISTS: 'STORE_ALREADY_EXISTS',
  AGGREGATOR_ALREADY_EXISTS: 'AGGREGATOR_ALREADY_EXISTS',
  INVALID_OOSTHRESHOLD: 'INVALID_OOSTHRESHOLD',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  NO_CONFIG_FOUND: 'NO_CONFIG_FOUND',
  LIMIT_FILE_SIZE: 'LIMIT_FILE_SIZE',
  INVALID_CRON_EXPRESSION: 'INVALID_CRON_EXPRESSION',
  FTP_ALREADY_RUNNING: 'FTP_ALREADY_RUNNING',
}
